import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import COMPONENT_LIST_PATCH from '../mutations/COMPONENT_LIST_PATCH';

const useComponentListPatch = () => {
    const [ patchComponentList ] = useMutation( COMPONENT_LIST_PATCH );

    const patchCList = async ( saveData ) => {
        try {
            const response = await patchComponentList( { variables: { input: saveData } } );
            const success = response?.data?.result?.componentListId;

            if ( success ) {
                return {
                    success: true,
                    response: response?.data?.result?.componentListId
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error patching component list', error );  
            return {
                success: false,
                response: false
            };
        } 
    };

    return useMemo( () => {
        return {
            patchCList         
        };
    }, [] );
};

export default useComponentListPatch;
